/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Split_EventInputs */

const en_shortcut_keys_desc_split_event = /** @type {(inputs: Shortcut_Keys_Desc_Split_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Split the selected event based on the cursor location`)
};

const fr_shortcut_keys_desc_split_event = /** @type {(inputs: Shortcut_Keys_Desc_Split_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diviser l'evenement selectionne selon la position du curseur`)
};

const de_shortcut_keys_desc_split_event = /** @type {(inputs: Shortcut_Keys_Desc_Split_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilen Sie das ausgewählte Ereignis anhand der Cursorposition auf.`)
};

const it_shortcut_keys_desc_split_event = /** @type {(inputs: Shortcut_Keys_Desc_Split_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dividi l'evento selezionato in base alla posizione del cursore`)
};

const ru_shortcut_keys_desc_split_event = /** @type {(inputs: Shortcut_Keys_Desc_Split_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разделите выбранное событие в зависимости от положения курсора.`)
};

const es_shortcut_keys_desc_split_event = /** @type {(inputs: Shortcut_Keys_Desc_Split_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dividir el evento seleccionado según la ubicación del cursor`)
};

const zh_cn2_shortcut_keys_desc_split_event = /** @type {(inputs: Shortcut_Keys_Desc_Split_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`根据光标位置拆分选定的事件`)
};

const ja_shortcut_keys_desc_split_event = /** @type {(inputs: Shortcut_Keys_Desc_Split_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カーソル位置に基づいて選択したイベントを分割します`)
};

const hi_shortcut_keys_desc_split_event = /** @type {(inputs: Shortcut_Keys_Desc_Split_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कर्सर की स्थिति के आधार पर चयनित इवेंट को विभाजित करें`)
};

const pt_pt2_shortcut_keys_desc_split_event = /** @type {(inputs: Shortcut_Keys_Desc_Split_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divida o evento selecionado com base na localização do cursor.`)
};

/**
* | output |
* | --- |
* | "Split the selected event based on the cursor location" |
*
* @param {Shortcut_Keys_Desc_Split_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_split_event = /** @type {((inputs?: Shortcut_Keys_Desc_Split_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Split_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_split_event(inputs)
	if (locale === "de") return de_shortcut_keys_desc_split_event(inputs)
	if (locale === "it") return it_shortcut_keys_desc_split_event(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_split_event(inputs)
	if (locale === "es") return es_shortcut_keys_desc_split_event(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_split_event(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_split_event(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_split_event(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_split_event(inputs)
	return en_shortcut_keys_desc_split_event(inputs)
});